<template>
    <div>
        <div class="container">
            <!-- 搜索框 -->
            <div class="seach-container">
                <div class="flex flex-wrap justify-between">
                    <!-- 用户名称 -->
                    <div class="form-container">
                        <div class="form-box-item">
                            <div class="form-box-item-label">
                            <span class="letterspance2">用户名称</span>
                            </div>
                            <div class="form-box-item-item">
                            <el-input
                                v-model="query.userName"
                                size="small"
                                placeholder="请输入用户名称"
                            ></el-input>
                            </div>
                        </div>
                    </div>
                    <!-- 是否工作人员 -->
                    <!-- <div class="form-container">
                        <div class="form-box-item">
                            <div class="form-box-item-label">
                            <span class="letterspance2">工作人员</span>
                            </div>
                            <div class="form-box-item-item">
                            <el-select v-model="query.isWorker" size="small" placeholder="请选择">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="普通用户" value="0"></el-option>
                                <el-option label="工作人员" value="1"></el-option>
                            </el-select>
                            </div>
                        </div>
                    </div> -->
                <!-- <el-form-item label="主调">
                    <el-select v-model="query.roleId" clearable size="small" placeholder="请选择">
                        <template v-for="role in roleList"  :key="role.RoleID">
                            <el-option :label="role.RoleName" :value="role.RoleID"></el-option>
                        </template>
                    </el-select>
                </el-form-item> -->
                    <div class="form-container">
                        <div class="form-box-item">
                            <div class="form-box-item-label">
                            <span class="letterspance2">角色</span>
                            </div>
                            <div class="form-box-item-item">
                            <el-select v-model="query.roleId" size="small" placeholder="请选择">
                                <el-option label="全部" value=""></el-option>
                                <template v-for="role in roleTreeData"  :key="role.RoleID">
                                       <el-option :label="role.RoleName" :value="role.RoleID"></el-option>
                                   </template>
                            </el-select>
                            </div>
                        </div>
                    </div>
                    <div class="form-container">
                        <div class="form-box-item">
                            <div class="form-box-item-label">
                            <span class="letterspance2">身份认证</span>
                            </div>
                            <div class="form-box-item-item">
                            <el-select v-model="query.isOcr" size="small" placeholder="请选择">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="否" value="0"></el-option>
                                <el-option label="是" value="1"></el-option>
                            </el-select>
                            </div>
                        </div>
                    </div>
                    <!-- 开始时间 -->
                    <div class="form-container">
                        <div class="form-box-item">
                            <div class="form-box-item-label">
                              <span>注册时间</span>
                            </div>
                            <div class="form-box-item-item">
                                <el-date-picker
                                    v-model="query.registerTimes"
                                    size="small"
                                    type="daterange"
                                    range-separator="-"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="form-container">
                        <div class="form-box-item serch-operate2">
                            <el-button type="primary" size="mini" icon="el-icon-search" @click="refreshList">搜索</el-button>
                            <el-button  icon="el-icon-delete" size="mini" @click="onClearCondtionChange">清空</el-button>
                        </div>
                    </div>
                </div>
            </div>
           <div class="addBtn">
                
            </div>
            <el-table
                :data="tableData"
                border
                :max-height="scrollHeight"
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header">
                <el-table-column
                    v-for="col in tableCols"
                    :key="col.prop"
                    :prop="col.prop"
                    :label="col.label"
                    :width="col.width"
                    :align="col.align">
                        <template #default="scope">
                            <div v-if="scope.column.property ==='IsWorker'">
                                {{getWorkerTypeName(scope.row.IsWorker)}}
                            </div>
                            <div v-else-if="scope.column.property ==='HeadImg'">
                                <img width="25" height="25" style="border-radius: 50%;" :src="scope.row.HeadImg"/>
                            </div>
                            <div v-else-if="scope.column.property ==='IsOcr'">
                                {{getOcrTypeName(scope.row.IsOcr)}}
                            </div>
                            <div v-else-if="scope.column.property ==='Operation'">
                                <el-button
                                    icon="el-icon-coordinate" 
                                    size="mini"
                                    type="info"
                                    @click="handleOAuto(scope.$index, scope.row)">授权
                                </el-button>
                                <el-button
                                    icon="el-icon-edit"
                                    size="mini"
                                    type="primary"
                                    @click="handleEdit(scope.$index, scope.row)">修改
                                </el-button>
                                <el-button
                                    icon="el-icon-delete"
                                    size="mini"
                                    type="danger"
                                    v-if="scope.row.IsOcr==1"
                                    @click="handleDelete(scope.$index, scope.row)">取消认证
                                </el-button>
                            </div>
                            <div v-else>
                                {{scope.row[scope.column.property]}}
                            </div>
                        </template>
                    </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                    :current-page="query.pageIndex"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="query.pageSize"
                    layout="total, sizes, prev, pager, next"
                    :total="pageTotal">
                </el-pagination>
            </div>
        </div>

        <!-- 处理弹出框 -->
        <el-dialog title="修改用户信息" custom-class="userManagePanel" v-model="editVisible" width="600px">
            <el-form :rules="rules" ref="ruleForm" class="returnMoneyClass" :model="returnItem" label-width="100px">
                <el-form-item label="微信昵称" :label-width="formLabelWidth">
                    <el-input disabled v-model="returnItem.WxNickName"></el-input>
                </el-form-item>
                <el-form-item label="登录用户名" :label-width="formLabelWidth" prop="UserName" >
                    <el-input v-model="returnItem.UserName"></el-input>
                </el-form-item>
                <el-form-item label="重置密码" :label-width="formLabelWidth" prop="Password" >
                    <el-input type="password" v-model="returnItem.Password"></el-input>
                </el-form-item>
                <el-form-item label="是否工作人员" :label-width="formLabelWidth">
                    <el-select v-model="returnItem.IsWorker" placeholder="请选择">
                        <el-option
                        v-for="item in workerTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="电话号码" :label-width="formLabelWidth" prop="Tel" >
                    <el-input v-model="returnItem.Tel"></el-input>
                </el-form-item>
                <!-- <el-form-item label="法大大号" :label-width="formLabelWidth"  >
                    <el-input v-model="returnItem.FddCode"></el-input>
                </el-form-item> -->
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button style="margin:0px 10px;" @click="editVisible = false">取消</el-button>
                    <el-button style="margin:0px 10px;" type="primary" @click="saveUserChange()">保存</el-button>
                </span>
            </template>
        </el-dialog>

        <!-- 授权弹出框 -->
        <el-dialog title="用户授权" v-model="oautVisible" width="600px">
            <el-form ref="detailForm" :model="returnItemOAut" label-width="110px">
                <el-row>
                    <el-col :span="22">
                        <el-form-item label="用户昵称">
                            <el-input disabled v-model="returnItemOAut.WxNickName"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="22">
                        <el-form-item label="登录名称">
                            <el-input disabled v-model="returnItemOAut.UserName"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="22">
                        <el-form-item label="选择角色">
                            <div style="height:200px;">
                                <el-scrollbar
                                    wrapClass="scrollbar-wrap"
                                    style="height:100%"
                                    ref="scrollbarContainer">
                                    <el-tree
                                        :data="roleTreeData"
                                        :props="props"
                                        show-checkbox
                                        node-key="RoleID"
                                        ref="roleTree" 
                                        :default-checked-keys="checkedRoles">
                                    </el-tree>
                                </el-scrollbar>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button style="margin:0px 10px;" @click="oautVisible = false">取消</el-button>
                    <el-button style="margin:0px 10px;" type="primary" @click="saveOAutChange()">授权</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
  import indexJs from "./index.js";
  export default indexJs;
</script>

<style scoped>
@import url(./assets/style/style.less);
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}


</style>
